import { useSelector } from 'react-redux';

import useFetchAccountInfo from 'hooks/useFetchAccountInfo';
import useFetchAllProductStyles from 'hooks/useFetchAllProductStyles';
import { selectCustomerEmailAddress } from 'selectors/account';
import { selectProduct } from 'selectors/sharing';

export function useCustomerEmail() {
  // fetch customerInfo so that we can access customer's `email` in the drawer form
  useFetchAccountInfo();

  const customerEmailAddress = useSelector(selectCustomerEmailAddress);

  return { customerEmailAddress };
}

export function useProductStock(productId: string) {
  // fetch all product styles so that we can access all the products stock, not just what's available
  useFetchAllProductStyles(productId);

  const product = useSelector(selectProduct);
  const stockData = product?.sizing?.stockData ?? [];

  return { stockData };
}
